import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import SetSales from './list';
import SetsOrders from './orders';
import SetSalesDetail from './detail';

export const setsRoutes = [
  {'component': <SetSales />, 'path': paths.SetSales},
  {'component': <SetSalesDetail />, 'path': paths.SetSalesDetail},
  {'component': <SetsOrders />, 'path': paths.SetsOrders},
];
